import apiClient from './client';

export interface User {
  id: number;
  username: string;
  email: string;
  role: string;
}

export const getUsers = async (params?: {
  role?: string;
  search?: string;
}): Promise<User[]> => {
  const response = await apiClient.get('/users', { params });
  return response.data.data || response.data || [];
};
